import axios from 'axios'
import qs from 'qs'

axios.defaults.withCredentials = true;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.timeout = 160000;
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL

export default axios



// WEBPACK FOOTER //
// ./src/api/axios.js